import { render, staticRenderFns } from "./SaleBrands.vue?vue&type=template&id=388d6973&scoped=true&"
import script from "./SaleBrands.vue?vue&type=script&lang=js&"
export * from "./SaleBrands.vue?vue&type=script&lang=js&"
import style0 from "./SaleBrands.vue?vue&type=style&index=0&id=388d6973&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388d6973",
  null
  
)

export default component.exports